module.exports = __webpack_public_path__ + "assets/62062d1c593352e830e78a5404307cdb.png";